import React from "react";
import styles from "css/mobile/mypage.module.css";
import moment from "moment";
import { t } from "i18next";
import { closeAlert, openConfirm } from "redux/slices/alertSlice";
import { useDispatch } from "react-redux";

export default function ScheduleCard({
  schedule,
  type,
  refresh,
  setSelectedSchedule,
  setIsOpenResDetail,
  setIsOpenParticipantDetail,
  setIsOpenEndpointDetail,
  openFavRes,
  deleteFavorite,
}) {
  // console.log(schedule);
  // type = current, favorite, past
  const dispatch = useDispatch();

  // 카드 우축 상단 "회의 시작 00분 전" 포멧
  const getLeftTime = (startTime) => {
    if (!startTime) {
      // 즐겨찾기 페이지인 경우 시간값 없음
      return { text: "즐겨찾기", className: "favorite" };
    }

    const now = moment();
    const start = moment(startTime);
    const diffMinutes = start.diff(now, "minutes");

    if (diffMinutes < 0) {
      return { text: "진행중", className: "ongoing" };
    }

    if (diffMinutes < 5) {
      return { text: "곧 시작", className: "imminent" };
    }

    if (diffMinutes < 60) {
      return { text: `시작 ${diffMinutes}분 전`, className: "minutes" };
    }

    const diffHours = start.diff(now, "hours");
    if (diffHours < 24) {
      const hours = Math.floor(diffHours);
      const minutes = diffMinutes % 60;

      if (minutes === 0) {
        return { text: `시작 ${hours}시간 전`, className: "hours" };
      }
      return { text: `시작 ${hours}시간 ${minutes}분 전`, className: "hours" };
    }

    const diffMonths = start.diff(now, "months");
    if (diffMonths > 0) {
      return { text: `시작 ${diffMonths}달 전`, className: "months" };
    }

    const diffDays = start.diff(now, "days");

    return { text: `시작 ${diffDays}일 전`, className: "days" };
  };

  // 카드 가운데 "00:00 pm - 00:00 pm" 시간 포멧
  const formatTimeRange = (startTime, endTime) => {
    if (!startTime || !endTime) {
      // return "00:00 pm - 00:00 pm";
      return;
    }

    const formatTime = (dateString) => {
      const date = new Date(dateString);
      return date
        .toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
        .toLowerCase();
    };

    const start = formatTime(startTime);
    const end = formatTime(endTime);

    return `${start} - ${end}`;
  };

  const openResDetail = () => {
    setSelectedSchedule(schedule);
    setIsOpenResDetail(true);
  };

  const openParticipantDetail = (e) => {
    e.stopPropagation();
    setSelectedSchedule(schedule);
    setIsOpenParticipantDetail(true);
  };

  const openEndpointDetail = (e) => {
    e.stopPropagation();
    setSelectedSchedule(schedule);
    setIsOpenEndpointDetail(true);
  };

  const handleDeleteClick = () => {
    deleteFavorite(schedule);
  };

  return (
    <>
      <div
        className={`${styles.card} ${styles[type]}`}
        onClick={() => type !== "favorite" && openResDetail()}
      >
        <div className={styles.cardHeader}>
          <div
            className={`${styles.statusBar} ${styles[type]} ${
              styles[getLeftTime(schedule.START_TIME).className]
            }`}
          />
          <div
            className={`${styles.beforeStartDate} ${styles[type]} ${
              styles[getLeftTime(schedule.START_TIME).className]
            }`}
          >
            {type === "current" && getLeftTime(schedule.START_TIME).text}
            {type === "past" && "회의 종료"}
            {/* {type === "favorite" && (
              <img
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/mobile/mypage/favorite.png"
                }
                alt="favorite"
              />
            )} */}
          </div>
        </div>
        <div className={styles.cardContent}>
          <h3 className={`${styles.title} ${styles[type]}`}>
            {schedule.TITLE}
          </h3>
          <div className={`${styles.datetime} ${styles[type]}`}>
            <span>
              {formatTimeRange(schedule.START_TIME, schedule.END_TIME)}
            </span>
          </div>
        </div>
        <div className={styles.cardBottom}>
          <div
            className={`${styles.participants} ${styles[type]}`}
            onClick={openParticipantDetail}
          >
            <img
              className={styles.peopleImg}
              src={
                process.env.REACT_APP_CLIENT_URL +
                `img/mobile/mypage/${
                  type === "past" ? "people_gray.png" : "people.png"
                }`
              }
              alt="people"
            />
            <span className={styles.participantCount}>
              {schedule.PARTICIPANT_LIST.length}
            </span>
            <img
              src={
                process.env.REACT_APP_CLIENT_URL +
                `img/mobile/mypage/${
                  type === "past" ? "dropdown_gray.png" : "dropdown.png"
                }`
              }
              alt="dropdown"
            />
          </div>
          {(type === "current" || type === "past") && (
            <>
              <div
                className={`${styles.endpoints} ${styles[type]}`}
                onClick={openEndpointDetail}
              >
                {schedule.ENDPOINT_LIST?.length > 0 &&
                  schedule.ENDPOINT_LIST.map(
                    (endpoint) => endpoint.ENDPOINT_NM
                  ).join(", ")}
              </div>
            </>
          )}
          {type === "favorite" && (
            <div className={styles.buttonArea}>
              <img
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/mobile/mypage/update.png"
                }
                alt="update"
                onClick={() => {
                  openFavRes(schedule, "U");
                }}
              />
              <img
                src={
                  process.env.REACT_APP_CLIENT_URL +
                  "img/mobile/mypage/delete.png"
                }
                alt="delete"
                onClick={(e) => {
                  const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.DELETE_SCD"),
                    submitEventHandler: () => {
                      handleDeleteClick();
                      dispatch(closeAlert());
                    },
                  };
                  dispatch(openConfirm(obj));
                  e.stopPropagation();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
